module.exports = __webpack_public_path__ + "img/about-icon-1.3fa879b6.svg";